export const withFluidColumn = (columns, fluidColumnId) =>
  columns.map((column) => ({
    ...column,
    meta: {
      ...column.meta,
      flexGrow: column.id === fluidColumnId ? 1 : 0,
    },
  }));
